<template>
  <div
    v-if="actions.length"
    class="action-bar"
  >
    <CarvisDivider />
    <div class="flex flex-col md:flex-row gap-2 md:justify-end">
      <CarvisButton
        v-for="action in actions"
        :key="action.text.normalText"
        :block="block || !md"
        :color="action.color"
        :disabled="action.disabled"
        :loading="loadingStates.has(action.text.normalText)"
        @click="onClick(action)"
      >
        <template #icon>
          <component
            :is="action.icon"
            :size="20"
          />
        </template>
        <span class="truncate">
          {{ md || !action.text.shortText ? action.text.normalText : action.text.shortText }}
        </span>
      </CarvisButton>
    </div>
    <CarvisDivider />
  </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { reactive } from 'vue'

defineProps<{
  actions: Action[]
  block?: boolean
}>()

const { md } = useBreakpoints(breakpointsTailwind)
const loadingStates = reactive(new Set<string>())

const onClick = async (action: Action): Promise<void> => {
  loadingStates.add(action.text.normalText)
  try {
    await action.onClick()
  } finally {
    loadingStates.delete(action.text.normalText)
  }
}
</script>

<style scoped>
.action-bar:first-child > :first-child {
  display: none;
}

.action-bar:not(:first-child) > :last-child {
  display: none;
}
</style>
